import { render } from "./DropdownAppointments.vue?vue&type=template&id=7508526e"
import script from "./DropdownAppointments.vue?vue&type=script&lang=ts"
export * from "./DropdownAppointments.vue?vue&type=script&lang=ts"
script.render = render

export default script